// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f9","3330": "1852a85d","494": "40775784","8481": "0d9b0ffb",}[chunkId] + ".css"
}